import { z } from "zod";

export const emailSchema = z.object({
  prenom: z
    .string()
    .trim()
    .max(50, "Prénom trop long")
    .optional()
    .or(z.literal("")),
  email: z.string().trim().email("Format d'email invalide").max(255),
  consent: z
    .boolean()
    .refine((v) => v === true, {
      message: "Vous devez accepter pour recevoir votre analyse",
    }),
});

export type EmailFormValues = z.infer<typeof emailSchema>;
